import React from 'react';
import { Dropdown, Space } from 'antd';
import { useModalState } from '../../../hooks/modalState';
import {
    TagProductActionsButtonContainer,
    TagMenu,
    TagProductActionsButton
} from './TagProductActions.styles';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Props } from './TagProductActions.types';
import DeleteModal from '../deleteModal/DeleteModal';
import { SubTitle } from '../../../styles/common.styles';
import { useAppSelector } from '../../../hooks/redux';
import { Tag } from '../../../redux/actions/tagActions/types';

const TagProductActions: React.FC<Props> = ({
    selectedCount,
    disabled,
    handleDelete,
    tagId,
}) => {
    const actionDropdown = useModalState();
    const deleteModal = useModalState();
    const tagName = useAppSelector((state) => state.tagReducer.tags.find((t: Tag) => t.id === tagId)?.name);

    const handleMenuSelect = (data: { key: string }) => {  
        if ('delete' === data.key && selectedCount > 0) {
            deleteModal.onOpen();
        }
    };

    const handleDeleteReload = () => {
        handleDelete();
        deleteModal.onClose();
        actionDropdown.onClose();
    };

    const tagActions = [
        {
            key: 'delete',
            label: 'Delete current tag',
        },
    ];

    const handleDeleteClose = () => {
        actionDropdown.onClose();
        deleteModal.onClose();
    };

    return (
        <div style={{ alignSelf: 'flex-end' }}>
            <Space>
                <Dropdown
                    menu={{
                        items: tagActions,
                        onClick: handleMenuSelect,
                        style: { top: -36 },
                    }}
                    placement="bottom"
                    trigger={['click']}
                    onOpenChange={(open) => (open ? actionDropdown.onOpen() : actionDropdown.onClose())}
                    disabled={disabled}
                >
                    <TagProductActionsButtonContainer>
                        <TagProductActionsButton id="tag-actions-button" disabled={disabled}>Actions</TagProductActionsButton>
                        <TagMenu id="tag-actions-menu" disabled={disabled}>
                            {actionDropdown.isOpen ? (
                                <CaretUpOutlined style={{ color: 'white' }} />
                            ) : (
                                <CaretDownOutlined style={{ color: 'white' }} />
                            )}
                        </TagMenu>
                    </TagProductActionsButtonContainer>
                </Dropdown>
            </Space>
            <DeleteModal
                isOpen={deleteModal.isOpen}
                closeModal={handleDeleteClose}
                reload={handleDeleteReload}
                title="current tag"
                text={<>tag <SubTitle>{tagName}</SubTitle> from {selectedCount} product{selectedCount !== 1 ? 's' : ''}</>}
                icon='tag-delete.svg'
            />
        </div>
    );
};

export default TagProductActions;
